import { ActionDetailComponent, ChangeDetailComponent } from './views';
import { Routes } from '@angular/router';
import { PlanType } from './core/enums/user';
import { HelpComponent } from './views/help/help.component';
import { AuthGuard } from './core/services/auth/auth.guard';
import { ErrorComponent } from './views/error/error.component';
import { AuthCallbackComponent } from './views/auth-callback/auth-callback.component';
import { ErrorMessageComponent } from './views/error-message/error-message.component';
import { PublishReportComponent } from './views/publish-report/publish-report.component';
import { PrivacyPolicyComponent } from './views/privacy-policy/privacy-policy.component';
import { ModalDialogComponent } from './views/distributed-ui-components/modal-dialog/modal-dialog.component';
import { SelfAssessmentRoutingComponentComponent } from './views/self-assessment-template3/self-assessment-routing-component/self-assessment-routing-component.component';
import { RiskControlsComponent } from './views/risk-controls/risk-controls.component';
import { RegulatoryInsightsGeneratorComponent } from './views/regulatory-insights-generator/regulatory-insights-generator.component';

export const AppRoutes: Routes = [
  { path: '', redirectTo: '', pathMatch: 'full' },
  { path: 'risk-control',
  component :RiskControlsComponent },
  // {
  //   path: 'lazy',
  //   loadChildren: () => import('./views/change-viewer/change-viewer.module').then(m => m.ChangeViewerModule),
  // },
  {
    path: 'change-viewer',
    loadChildren: () =>
      import('./views/change-viewer/change-viewer.module').then(
        (m) => m.ChangeViewerModule
      ),
    canActivate: [AuthGuard],
    data: { disabledForPlanType: PlanType.Suisse },
  },
  {
    path: 'change-detail',
    component: ChangeDetailComponent,
    canActivate: [AuthGuard],
    data: { disabledForPlanType: null },
  },
  {
    path: 'action-detail/:id',
    component: ActionDetailComponent,
    canActivate: [AuthGuard],
    data: { disabledForPlanType: PlanType.Suisse },
  },
  {
    path: 'impact-assessment',
    loadChildren: () =>
      import('./views/impact-assessment/impact-assessment.module').then(
        (m) => m.ImpactAssessmentModule
      ),
    canActivate: [AuthGuard],
    data: { disabledForPlanType: PlanType.Suisse },
  },

  {
    path: 'self-assessment',
    loadChildren: () =>
      import('./views/self-assessment/self-assessment.module').then(
        (m) => m.SelfAssessmentModule
      ),
    canActivate: [AuthGuard],
    data: { disabledForPlanType: PlanType.Suisse },
  },
  {
    path: 'library',
    loadChildren: () =>
      import('./views/library/library.module').then((m) => m.LibraryModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'user-management',
    loadChildren: () =>
      import('./views/user-management/user-management.module').then(
        (m) => m.UserManagementModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'scheduler',
    loadChildren: () =>
      import('./views/assesment-scheduler/assesment-scheduler.module').then(
        (m) => m.AssesmentSchedulerModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'help',
    component: HelpComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'publish-report',
    component: PublishReportComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'regulatory-insights-generator',
    component: RegulatoryInsightsGeneratorComponent,
    canActivate: [AuthGuard],
    data: { disabledForPlanType: PlanType.Suisse }
  },
  { path: '', component: ModalDialogComponent },
  { path: 'auth-callback', component: AuthCallbackComponent },
  { path: 'not-found', component: ErrorComponent },
  { path: 'error-found', component: ErrorMessageComponent },
  { path: '**', redirectTo: 'not-found' },
];
